import { PropsWithChildren, ReactElement } from 'react';

type Props = {
  title?: string;
};

function TabbedFolderSection(
  props: PropsWithChildren<Props>
): ReactElement<HTMLElement> {
  return (
    <section className="mb-16 last:mb-0">
      <div className="rounded-xl relative bg-white">
        {props.title && (
          <h2 className="mx-5 -mt-5 py-1.5 w-32 rounded-xl absolute right-0 bg-white text-center text-primary font-display lg:text-lg">
            {props.title}
          </h2>
        )}
        <div className="py-10 px-5">{props.children}</div>
      </div>
    </section>
  );
}

export default TabbedFolderSection;
